'use client';
import React, { useEffect } from 'react';
import Button from '../next-ui/Button';
import useJoinNonProfitDialogStore from '../store/joinNonProfitDialogSlice';
import useStore from '@/stores/store';
import { isEmpty } from 'lodash-es';
import useHasUserSession from '@/hooks/useHasUserSession';
import Tooltip from '@ui/Tooltip';
import { useRouter } from 'next/navigation';
import { authorizedServerFetch } from '@/actions/server.actions';
import useNonProfitSignUpPopUpStore from '../store/nonProfitSignUpPopUpSlice';
import useCompanyConnectPopUpStore from '../store/companyConnectPopUpSlice';

function JoinNonProfitButton(props) {
  const {
    nonProfit,
    variant = 'outlined',
    color = 'primary',
    pendingApproval = false,
    ...rest
  } = props;
  const isClaimed = nonProfit?.isClaimed;
  const companyId = nonProfit?.company_id;
  const hasSession = useHasUserSession();
  const userCommunities = useStore((state) => state.user?.profile?.communities);

  const [canJoin, setCanJoin] = React.useState(false);

  const setShowJoinNonProfitModal = useJoinNonProfitDialogStore(
    (state) => state.setOpen,
  );

  const setShowNonProfitSignUpPopUp = useNonProfitSignUpPopUpStore(
    (state) => state.setOpen,
  );
  const setShowCompanyConnectPopUp = useCompanyConnectPopUpStore(
    (state) => state.setOpen,
  );

  const router = useRouter();

  useEffect(() => {
    if (!hasSession) {
      setCanJoin(true);
    } else if (!isEmpty(userCommunities)) {
      setCanJoin(
        isClaimed && userCommunities.every((c) => c.communityId !== companyId),
      );
      // setCanJoin(userCommunities.every((c) => c.communityId !== companyId));
    }
  }, [userCommunities, isClaimed, companyId, hasSession]);

  const handleJoin = () => {
    if (hasSession) {
      if (nonProfit?.company?.visibilityType === 'public') {
        submitPublicNonProfitApplication();
      } else {
        setShowJoinNonProfitModal(true, nonProfit);
      }
    } else {
      // setShowJoinNonProfitModal(false, nonProfit);
      // const returnPath = `/onboard/nonprofit-user?nonProfitId=${nonProfit?.id}`;
      // router.replace(
      //   `/api/auth/signup?returnTo=${encodeURIComponent(returnPath)}`,
      // );
      setShowNonProfitSignUpPopUp(true, nonProfit);
    }
  };

  const submitPublicNonProfitApplication = async () => {
    const res = await authorizedServerFetch(
      `users/me/nonprofit/${nonProfit.id}/apply`,
      {
        method: 'POST',
        body: JSON.stringify({
          message: '',
        }),
      },
    );

    if (res?.ok) {
      setShowJoinNonProfitModal(true, nonProfit, 'success');
    } else {
      if (res?.status === 409) {
        setShowJoinNonProfitModal(true, nonProfit, 'error');
      } else {
        setShowJoinNonProfitModal(true, nonProfit, 'backend-error');
      }
    }
  };

  if (pendingApproval) {
    return (
      <Tooltip content="Pending Approval" className="w-max">
        <Button variant={variant} color={color} {...rest} disabled>
          Join
        </Button>
      </Tooltip>
    );
  }

  if (canJoin) {
    return (
      <Button variant={variant} color={color} {...rest} onClick={handleJoin}>
        Join
      </Button>
    );
  }
  return null;
}

export default JoinNonProfitButton;
